import React from 'react'
import { connect } from 'react-redux'
import { Routes, Route } from 'react-router-dom'
import { withRouterProps } from '../../utils/with-router-props'

import ChefPortalAvailability from './view'


const AdminChefAvailabilityIndex = () => {
    return (
        <>
            <Routes>
                <Route index element={<ChefPortalAvailability />} />
            </Routes>
        </>
    )
}

export default withRouterProps(connect()(AdminChefAvailabilityIndex))
